module.exports = __webpack_public_path__ + "img/logoB.f3a979f1.png";